import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement(
    'g',
    { clipPath: 'url(#clip0)' },
    React.createElement('path', {
      d: 'M18.4492 22.0625C18.2892 22.0625 18.1283 22.0017 18.0067 21.8792L10.1208 13.9792C9.87751 13.735 9.87751 13.3392 10.1217 13.0958C10.3658 12.8525 10.7625 12.8525 11.0067 13.0967L18.8925 20.9958C19.1358 21.24 19.1358 21.6358 18.8917 21.88C18.7692 22.0017 18.6092 22.0625 18.4492 22.0625Z',
      fill: '#34323A'
    }),
    React.createElement('path', {
      d: 'M13.895 25.9998C13.3517 25.9998 12.8067 25.7923 12.3925 25.3781L6.62083 19.6065C6.22083 19.2065 6 18.6723 6 18.104C6 17.5356 6.22083 17.0015 6.62083 16.6015L16.6025 6.61981C17.43 5.79147 18.7783 5.79064 19.6075 6.61981L25.3792 12.3915C25.7792 12.7915 26 13.3256 26 13.894C26 14.4623 25.7792 14.9965 25.3792 15.3965L15.3975 25.3781C14.9833 25.7923 14.4392 25.9998 13.895 25.9998V25.9998ZM13.2758 24.494C13.6167 24.8356 14.1708 24.8365 14.5133 24.494L24.495 14.5123C24.8358 14.1706 24.8358 13.6156 24.495 13.2748L18.7233 7.50314C18.3817 7.16147 17.8275 7.16314 17.4858 7.50314L7.505 17.4848C7.16417 17.8265 7.16417 18.3815 7.505 18.7223L13.2758 24.494Z',
      fill: '#34323A'
    })
  ),
  React.createElement(
    'defs',
    null,
    React.createElement(
      'clipPath',
      { id: 'clip0' },
      React.createElement('rect', { x: '6', y: '6', width: '20', height: '20', fill: 'white' })
    )
  )
));